import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { CancelPresentation, Save, Clear, Check } from '@material-ui/icons';

export default class ModalPregunta extends Component {
  constructor(props, context) {
    super(props, context);
    // this.escFunction = this.escFunction.bind(this);
  }
  componentDidMount() {

    // document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    // document.removeEventListener("keydown", this.escFunction, false);
  }

  parseMarkdown = (md = '') => {
    return md
      .replace(/^#{5}\ ?(.+)/gm, '<h5>$1</h5>')
      .replace(/^#{4}\ ?(.+)/gm, '<h4>$1</h4>')
      .replace(/^#{3}\ ?(.+)/gm, '<h3>$1</h3>')
      .replace(/^#{2}\ ?(.+)/gm, '<h2>$1</h2>')
      .replace(/^#{1}\ ?(.+)/gm, '<h1>$1</h1>')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(/\n/g, '<br/>');
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.props.show} className="static-modal" backdrop={"static"}>
          <Card >
            <CardHeader color={(this.props.headerColor == null || this.props.headerColor == undefined ? "danger" : this.props.headerColor)}>
              <div dangerouslySetInnerHTML={{ __html: this.parseMarkdown(this.props.Titulo) }} />
            </CardHeader>
            <CardBody>
              <div dangerouslySetInnerHTML={{ __html: this.parseMarkdown(this.props.Cuerpo) }} />
              <GridItem>
                <Button size="sm" color="success" round className="pull-right" onClick={() => this.props.eventClick(true)}><Check />&nbsp;ACEPTAR</Button>
                <Button size="sm" color="danger" round className="pull-right mr-2" onClick={() => this.props.eventClick(false)}><Clear />&nbsp;CANCELAR</Button>
              </GridItem>
            </CardBody>
          </Card>
        </Modal>
      </div>
    );
  }
}